import React from 'react';
import { Chip, Stack } from '@mui/material';
import { shellTokens } from '../../shell/theme/shellTheme';

const ParamChips = ({ params = [] }) => {
    if (!params.length) {
        return null;
    }

    return (
        <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
            {params.map((param) => (
                <Chip
                    key={`${param.label}:${param.value}`}
                    label={`${param.label} ${param.value}`}
                    size="small"
                    sx={{
                        height: 22,
                        fontSize: '0.68rem',
                        fontWeight: 600,
                        bgcolor: 'rgba(100, 116, 139, 0.08)',
                        color: shellTokens.muted,
                        '& .MuiChip-label': { px: 0.85 },
                    }}
                />
            ))}
        </Stack>
    );
};

export default ParamChips;
